module.exports = __webpack_public_path__ + "img/exelIcon.682a5c3e.png";